import { ADD_RESULTS } from "../constants/resultsConstants";

const resultsReducer = (state = [], action) => {
  switch (action.type) {
    case ADD_RESULTS:
      if (Array.isArray(action.payload)) {
        return [...state, ...action.payload];
      } else {
        return [...state, action.payload];
      }
    default:
      return state;
  }
};

export default resultsReducer;
